export const ChevronIcon = ({ className, ...props }: JSX.HTMLAttributes<SVGSVGElement>) => (
  <svg viewBox="0 0 19 10" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
    <path
      d="M9.5 9.318l.728-.59 7.863-6.38-1.457-1.62L9.5 6.517 2.366.728.909 2.347l7.863 6.38.728.59z"
      fill="currentColor"
    />
  </svg>
)
